export default __webpack_public_path__ + "349e8b0c4a62579d738833cb2d87f26a.png";